<p-dialog header="Add Contact History Record" [modal]="true" [dismissableMask]="true"
  [(visible)]="isAddContactHistoryModalVisible" [breakpoints]="{ '1400px': '50vw', '1200px': '75vw', '992px': '90vw' }"
  [style]="{ width: '25rem' }">
  <form [formGroup]="addContactHistoryForm" (ngSubmit)="onSubmit()">
    <div class="col mb-3">
      <label class="form-label" for="contactType">Contact Type</label>
      <select class="form-select" id="contactType" formControlName="contactType">
        <option *ngFor="let type of contactTypes" [value]="type.surveyContactTypeId">{{ type.name }}</option>
      </select>
    </div>

    <div class="flex justify-content-end gap-2">
      <button class="btn btn-link" type="button" (click)="toggleAddContactHistoryModal()">Cancel</button>
      <button class="btn btn-primary" type="submit" [disabled]="addContactHistoryForm.invalid">Save</button>
    </div>
  </form>

</p-dialog>